export default __webpack_public_path__ + "images/ebed8756915eb9790ea8e3cd2bf6c925.png";